export default "__VITE_ASSET__0f2ebde8__"